import { erpAxios } from '..';

const fetchKomitent = async (jmbg) => {
  const { data } = await erpAxios.get(`/komitenti/${jmbg}`);
  return data.id ? data : null;
};

export default fetchKomitent;
